import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getFetchURL } from "src/helpers/actionHelpers";
import { getSessionCompanyId } from "src/helpers/sessionHelper";

const initialState = {
  filteredCustomersList: [],
  customer: [],
  filteredColorList: []
};

export const createCustomer = createAsyncThunk("modalEdit/createCustomer", async (apiData, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/customer/insert")
  };

  const response = await axios(options);

  return response.data;
});

export const editCustomer = createAsyncThunk("modalEdit/editCustomer", async (apiData, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/customer/edit")
  };

  const response = await axios(options);

  return response.data;
});

export const fetchFilteredCustomers = createAsyncThunk(
  "modalEdit/fetchFilteredCustomers",
  async (filterText, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/customer/find/${getSessionCompanyId()}/${filterText}`));

    return response.data;
  }
);


export const fetchColors = createAsyncThunk(
  "modalEdit/fetchColors",
  async (filterText, { dispatch }) => {
    const response = await axios.get(getFetchURL(`/color/get`));

    return response.data;
  }
);


export const deleteCustomer = createAsyncThunk("modalEdit/deleteCustomer", async (id, { dispatch }) => {
  const options = {
    method: "DELETE",
    data: { id: id },
    url: getFetchURL("/customer/delete")
  };

  const response = await axios(options).then((_) => {
    dispatch(fetchFilteredCustomers());
  });

  return response.data;
});

export const modalEditSlice = createSlice({
  name: "modalEdit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.filteredCustomersList.push(action.payload);
        state.customer = action.payload;
      })
      .addCase(editCustomer.fulfilled, (state, action) => {
        const indexOfElement = state.filteredCustomersList.findIndex(obj=>obj.id === action.payload.id);
        state.filteredCustomersList[indexOfElement] = action.payload;
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.filteredCustomersList = action.payload;
      })
      .addCase(fetchFilteredCustomers.fulfilled, (state, action) => {
        state.filteredCustomersList = action.payload;
      })
      .addCase(fetchColors.fulfilled, (state, action) => {
//      .addCase(fetchAllColors.fulfilled, (state, action) => {
        state.filteredColorList = action.payload;
      });

  }
});

export default modalEditSlice.reducer;
